import { isApiNotFoundStatus } from '../../utils/api'
import {
  updatePaginationCount,
  updatePaginationPage,
} from '../../utils/pagination'
import { parseToOldApiOrdering } from '../../utils/sort'

import {
  OLD_API_LIST_FIRST_PAGE,
  OLD_API_LIST_PAGE_STEP,
} from './useOldApiListTable.constants'

export function isOldApiListLoaded(items) {
  return items != null
}

export function hasOldApiListItems(items) {
  return items?.length > 0
}

export function isOldApiListPageMissing({ error, pagination }) {
  return (
    isApiNotFoundStatus(error?.response?.status) &&
    pagination.page > OLD_API_LIST_FIRST_PAGE
  )
}

export function getOldApiListPaginationParams(pagination) {
  return { page: pagination.page, page_size: pagination.pageSize }
}

export function getOldApiListParams({ ordering, pagination }) {
  return {
    ...getOldApiListPaginationParams(pagination),
    ...parseToOldApiOrdering(ordering),
  }
}

export function getOldApiListTableKey({ listKey, ordering }) {
  return JSON.stringify({ listKey, ordering })
}

export function getOldApiListPreviousPagination(pagination) {
  return updatePaginationPage(
    pagination,
    pagination.page - OLD_API_LIST_PAGE_STEP
  )
}

export function getOldApiListFirstPagination(pagination) {
  return updatePaginationPage(pagination, OLD_API_LIST_FIRST_PAGE)
}

export function getOldApiListPageSizePagination({ pageSize, pagination }) {
  return {
    ...getOldApiListFirstPagination(pagination),
    pageSize,
  }
}

export function getOldApiListPagination({ meta, pagination }) {
  return updatePaginationCount(
    { ...pagination, pageCount: meta.page_count },
    meta.count
  )
}

export function isOldApiListTableKeyShown({ items, listKey, shownListKey }) {
  return isOldApiListLoaded(items) && listKey === shownListKey
}

export function isOldApiListTableLatestLoad({
  isMounted,
  latestLoadPageId,
  loadPageId,
}) {
  return isMounted && loadPageId === latestLoadPageId
}

export function isOldApiListTableLoading({
  columns,
  isInitiated,
  isLoadFailed,
}) {
  const isWaiting = !isInitiated || !columns

  return !isLoadFailed && isWaiting
}

export function updateOldApiListTableItem({ id, items, updates }) {
  // A row update can settle after a failed reload has dropped the rows.
  return isOldApiListLoaded(items)
    ? items.map(item => (item.id === id ? { ...item, ...updates } : item))
    : items
}
